import { useState } from 'react';
import { Link } from 'react-router-dom';

const footerNavLinks = [
  { name: '首页', path: '/' },
  { name: '网红爆料', path: '/category/wanghong-baoliao' },
  { name: '娱乐圈', path: '/category/yule-quan' },
  { name: '直播圈', path: '/category/zhibo-quan' },
  { name: '关于我们', path: '/about' },
];

const socialLinks = [
  { name: '微博', icon: 'ri-weibo-line', href: '#' },
  { name: '微信公众号', icon: 'ri-wechat-line', href: '#' },
  { name: '抖音', icon: 'ri-tiktok-line', href: '#' },
];

export default function Footer() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [statusMsg, setStatusMsg] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const hpVal = (formData.get('website_alt') as string || '').trim();
    if (hpVal) {
      setStatus('success');
      setStatusMsg('订阅成功！感谢您的关注。');
      setEmail('');
      return;
    }

    setStatus('loading');
    try {
      const resp = await fetch('http://baiducc.cn/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email: formData.get('email') as string }).toString(),
      });
      const responseText = await resp.text();
      let parsed: Record<string, unknown> | null = null;
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }
      if (resp.ok && parsed && (parsed as { code?: string }).code === 'OK') {
        setStatus('success');
        setStatusMsg('订阅成功！感谢您的关注。');
        setEmail('');
      } else {
        const serverMsg = (parsed && (parsed as { meta?: { message?: string } }).meta?.message) || responseText;
        setStatus('error');
        setStatusMsg(typeof serverMsg === 'string' ? serverMsg : '订阅失败，请稍后重试');
      }
    } catch {
      setStatus('error');
      setStatusMsg('网络错误，请稍后重试');
    }
  };

  return (
    <footer className="px-4 md:px-6 py-10 md:py-14">
      <div className="max-w-7xl mx-auto bg-foreground-900 rounded-2xl px-6 md:px-10 py-10 md:py-14 relative overflow-hidden">
        <div className="absolute inset-0 pointer-events-none select-none opacity-[0.04]">
          <span className="absolute bottom-0 left-0 text-[12rem] leading-none font-heading font-black text-background-50 whitespace-nowrap">
            黑料在线
          </span>
        </div>

        <div className="relative z-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <h3 className="text-xl md:text-2xl font-bold font-heading text-background-50 mb-4">
              第一时间<br />获取最新爆料
            </h3>
            <p className="text-sm text-foreground-400 leading-relaxed">
              黑料在线 — 网红八卦资讯聚合平台，每日实时更新最新爆料，吃瓜追瓜一站搞定。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <ul className="flex flex-col gap-2">
              {footerNavLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-foreground-400 hover:text-background-50 transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">关注我们</h4>
            <ul className="flex flex-col gap-3">
              {socialLinks.map((social) => (
                <li key={social.name}>
                  <a
                    href={social.href}
                    className="flex items-center gap-2 text-sm text-foreground-400 hover:text-background-50 transition-colors"
                    rel="nofollow"
                  >
                    <i className={`${social.icon} text-base`}></i>
                    {social.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">订阅爆料推送</h4>
            <p className="text-xs text-foreground-400 mb-3">第一时间获取最新吃瓜资讯</p>
            <form onSubmit={handleSubmit}>
              <div className="flex">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="输入邮箱地址"
                  required
                  className="flex-1 bg-foreground-800 text-background-50 text-sm px-4 py-2.5 rounded-l-full outline-none placeholder:text-foreground-500 border border-foreground-700 focus:border-accent-500 transition-colors"
                />
                <button
                  type="submit"
                  disabled={status === 'loading'}
                  className="whitespace-nowrap px-5 py-2.5 bg-accent-500 text-background-50 rounded-r-full text-sm font-medium hover:bg-accent-600 transition-colors cursor-pointer disabled:opacity-60"
                >
                  {status === 'loading' ? (
                    <i className="ri-loader-4-line animate-spin"></i>
                  ) : (
                    <i className="ri-arrow-right-line"></i>
                  )}
                </button>
              </div>
              <input type="text" name="website_alt" className="form-hp-field" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
              {status !== 'idle' && (
                <p className={`text-xs mt-2 ${status === 'success' ? 'text-accent-400' : 'text-red-400'}`}>
                  {statusMsg}
                </p>
              )}
            </form>
          </div>
        </div>

        <div className="relative z-10 mt-10 pt-6 border-t border-foreground-800 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 黑料在线 版权所有 | 内容仅供娱乐参考
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors">用户协议</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}